import logo from "../components/logos/Duo Amigo-logos.jpeg"
function Main() {
    return (
      <div className="bg-blue-600 ">
        <img className="mx-auto" src={logo} alt="Logo"/>
      </div>
    )
  }
  
  export default Main;